import {
  RESET_STATE,
  SIGN_IN_CALL_FAILURE,
  SIGN_IN_CALL_REQUEST,
  SIGN_IN_CALL_SUCCESS,
  START_SIGN_OUT,
  SUCCESS_SIGN_OUT,
  FAILED_SIGN_OUT, SET_MENUS,
} from '../actions/login';
import { AuthenticationState } from 'react-aad-msal';
import {
  AAD_ACQUIRED_ID_TOKEN_SUCCESS,
  AAD_LOGIN_SUCCESS,
  AAD_LOGIN_FAILED,
  AAD_LOGIN_ERROR,
  AAD_AUTHENTICATED_STATE_CHANGE,
} from '../actions/aad_login';
import { navMenu } from '../../../layouts/Main/components/Topbar/navMenu';

const SIGN_IN_INITIAL_STATE = {
  isSigningInProgress: false,
  isSigningOutProgress: false,
  signedIn: false,
  response: {},
  isError: false,
  menus: navMenu.menus,
};

export default (state = SIGN_IN_INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGN_IN_CALL_REQUEST:
      return {
        ...state,
        isSigningInProgress: true,
        response: {},
        signedIn: false,
        isError: false,
      };
    case SIGN_IN_CALL_SUCCESS:
    case AAD_LOGIN_SUCCESS:
      return {
        ...state,
        isSigningInProgress: false,
        response: action.payload,
        signedIn: true,
        isError: false,
      };
    case AAD_ACQUIRED_ID_TOKEN_SUCCESS:
      return {
        ...state,
        response: {
          ...state.response,
          jwtIdToken: action.payload?.idToken?.rawIdToken || state.response?.jwtIdToken,
        },
        signedIn: true,
      };
    case SIGN_IN_CALL_FAILURE:
      return {
        ...state,
        isSigningInProgress: false,
        signedIn: false,
        response: action.payload,
        isError: true,
      };
    // isSigningInProgress se persiste en sessionStorage; sin estos casos un login
    // cancelado o fallido dejaba el flujo bloqueado en "en progreso" para siempre.
    case AAD_LOGIN_FAILED:
    case AAD_LOGIN_ERROR:
      return {
        ...state,
        isSigningInProgress: false,
        signedIn: false,
        isError: true,
      };
    // MSAL es la fuente de verdad: si reporta Unauthenticated pero el estado
    // rehidratado de sessionStorage dice signedIn, se corrige (logout interrumpido).
    case AAD_AUTHENTICATED_STATE_CHANGE:
      if (action.payload === AuthenticationState.Unauthenticated && state.signedIn) {
        return {
          ...state,
          isSigningInProgress: false,
          signedIn: false,
          response: {},
        };
      }
      return state;
    case START_SIGN_OUT:
      return {
        ...state,
        isSigningOutProgress: true,
        isError: false,
      };
    case SUCCESS_SIGN_OUT:
      return {
        ...state,
        ...SIGN_IN_INITIAL_STATE,
      };
    case FAILED_SIGN_OUT:
      return {
        ...state,
        isSigningOutProgress: false,
        response: action.payload,
        isError: true,
      };
    case RESET_STATE:
      return { ...SIGN_IN_INITIAL_STATE };
    case SET_MENUS:
      return {
        ...state,
        menus: action.payload,
      };
    default:
      return state;
  }
};

// selectors
export const getUser = (state) => state.login.response;
